module.exports = __webpack_public_path__ + "static/media/menu-mobile-hamburger.e35fbe32.svg";